// import axios from "axios";

export const getVimeoLink = (url) => {
	return new Promise((resolve, rejct) => {
		if (url !== undefined || url !== "") {
			var regExp = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
			var match = url.match(regExp);
			if (match) {
				resolve(`https://player.vimeo.com/video/${match[3]}`);
			}
			//API TO GET EMBED LINK FROM VIMEO
			// axios
			// 	.get(`https://vimeo.com/api/oembed.json?url=${url}`)
			// 	.then((res) => {
			// 		resolve(
			// 			`https://player.vimeo.com/video/${res.data.video_id}`
			// 		);
			// 	})
			// 	.catch((e) => {
			// 		resolve(false);
			// 	});
		} else {
			resolve(false);
		}
	});
};

export const getYoutubeLink = (url) => {
	return new Promise((resolve, reject) => {
		if (url !== undefined || url !== "") {
			var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
			var match = url.match(regExp);
			if (match && match[2].length === 11) {
				// Do anything for being valid youtube url
				resolve(
					"https://www.youtube.com/embed/" +
						match[2] +
						"?autoplay=0&enablejsapi=1"
				);
			} else {
				// Do anything for not being valid
				resolve(false);
			}
		} else {
			resolve(false);
		}
	});
};
